<div class="body-header">
  <div class="headerMain">
    <div class="flex topHeader">
      <div class="flex mt-3" routerLink="">
        @if (logoUrl) {
          <img [src]="logoUrl" [alt]="siteName + ' logo'" width="100px" height="50px">
        }
        <div class="logoItem" [class.ms-3]="logoUrl">{{siteName}}</div>
      </div>
      @if (backOffice) {
        <div class="fs-1 fw-bold">Backoffice</div>
      }
      <div class="flex menuBar">
        <div class="menuText">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" style="z-index: 14;">
            @if (loggedOut) {
              <button mat-menu-item (click)="loginBoxShow()">
                <mat-icon>login</mat-icon>
                <span>Login</span>
              </button>
            }
            @if (!loggedOut) {
              <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Log Out</span>
              </button>

              @if (showUserOptions) {
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="customer">
                  <mat-icon>person</mat-icon>
                  <span>My Account</span>
                </button>
              }

              @if (showCompanyOptions) {
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="backoffice">
                  <mat-icon>store</mat-icon>
                  <span>Company Dashboard</span>
                </button>
                <button mat-menu-item routerLink="backoffice/all-stores">
                  <mat-icon>business</mat-icon>
                  <span>Manage Stores</span>
                </button>
              }

              @if (showAdminOptions) {
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="admin">
                  <mat-icon>admin_panel_settings</mat-icon>
                  <span>Admin Panel</span>
                </button>
              }
            }
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loginSignUp) {
  <div class="login-modal-container">
    <div class="screenFade" (click)="loginBoxHide()"></div>
    <div class="login-modal-content">
      <app-login-signup (loginBoxHide)="loginBoxHide()"></app-login-signup>
    </div>
  </div>
}

@if (searchbar) {
  <div class="flex bottomheader">
    <div class="searchBar">
      <div class="flex datePickerForm mediaMargins">
        <div class="flex flexColumn">
          <label class="lblAddDates">Add dates</label>
          <div class="flex">
            <input class="datePickerInput" id="startDate" type="date">
            <input style="margin-left: 5px;" class="datePickerInput" id="endDate" type="date">
          </div>
        </div>
      </div>
    </div>
  </div>
}
